// extracted by mini-css-extract-plugin
module.exports = {"container":"BillingHistory_container__SH34u","divider":"BillingHistory_divider__T1dlL","title":"BillingHistory_title__aCEpq","disclaimer":"BillingHistory_disclaimer__gAJbY"};